import { render, staticRenderFns } from "./DotationView.vue?vue&type=template&id=a411f160&scoped=true"
import script from "./DotationView.vue?vue&type=script&lang=js"
export * from "./DotationView.vue?vue&type=script&lang=js"
import style0 from "./DotationView.vue?vue&type=style&index=0&id=a411f160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a411f160",
  null
  
)

export default component.exports